class SettingsStoreFront {

    constructor() {
        this.apiClient = new StorefrontApiClient();
        this.cartService = new CartService();

        this.initSettings();
    }


    initSettings() {
        if (!window.purpleTheme.config.storefrontClient.client)
            window.purpleTheme.config.storefrontClient.client = this.apiClient;

        if (!window.purpleTheme.config.storefrontClient.cartService)
            window.purpleTheme.config.storefrontClient.cartService = this.cartService;

        const discountInput = document.querySelector('input[name="discount"]');
        const applyDiscountBtn = document.querySelector('.coupon button');
        const totalEl = document.getElementById('CartTotal');

        if (discountInput && applyDiscountBtn) {
            applyDiscountBtn.addEventListener('click', async () => {
                const discountCode = discountInput.value.trim();

                if (!discountCode) {
                    discountInput.focus();
                    return;
                }

                applyDiscountBtn.innerText = 'Processando...';
                applyDiscountBtn.disabled = true;

                try {
                    const rawCartRequest = await fetch('/cart.js');
                    const rawCartData = await rawCartRequest.json();
                    const graphqlCartId = `gid://shopify/Cart/${rawCartData.token}`;

                    const response = await cartService.applyDiscount(graphqlCartId, discountCode);
                    const mutationResult = response.data.cartDiscountCodesUpdate;

                    if (mutationResult.userErrors.length > 0) {
                        throw new Error(mutationResult.userErrors[0].message);
                    }

                    const activeDiscount = mutationResult.cart.discountCodes.find(d => d.code === discountCode);

                    if (!activeDiscount || !activeDiscount.applicable) {
                        throw new Error('Cupom não aplicável aos itens do carrinho.');
                    }

                    const newTotalAmount = mutationResult.cart.cost.totalAmount.amount;

                    const formatMoney = (amount) => {
                        return parseFloat(amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                    };

                    totalEl.innerText = formatMoney(newTotalAmount);

                    applyDiscountBtn.innerText = 'Aplicado';
                    applyDiscountBtn.style.backgroundColor = '#198754';
                    applyDiscountBtn.style.color = '#fff';
                    applyDiscountBtn.style.borderColor = '#198754';
                    discountInput.style.pointerEvents = 'none';

                } catch (error) {
                    applyDiscountBtn.innerText = 'Aplicar';
                    applyDiscountBtn.disabled = false;

                    // Don't show technical JS exceptions via alert to the client
                    if (error instanceof TypeError || error.message.includes('not a function')) {
                        console.error('Coupon Error:', error.message);
                    } else {
                        console.error('Coupon Error:', error.message);
                    }
                }
            });
        }
    }
}

new SettingsStoreFront();